'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = pendingUserFollows;

var _actionTypes = require('../../actions/action-types');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function buildFeedUserIdKeyFromAction(action) {
  var _action$payload = action.payload,
      feedUserType = _action$payload.feedUserType,
      feedUserRelatedId = _action$payload.feedUserRelatedId;

  return feedUserType + '-' + feedUserRelatedId;
}

function pendingUserFollows() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];

  var feedUserIdKey = void 0;

  switch (action.type) {
    case _actionTypes.REQUEST_FOLLOW_USER:
    case _actionTypes.REQUEST_UNFOLLOW_USER:
      feedUserIdKey = buildFeedUserIdKeyFromAction(action);
      return [].concat(_toConsumableArray(state), [feedUserIdKey]);
    case _actionTypes.SUCCESS_FOLLOW_USER:
    case _actionTypes.FAIL_FOLLOW_USER:
    case _actionTypes.SUCCESS_UNFOLLOW_USER:
    case _actionTypes.FAIL_UNFOLLOW_USER:
      feedUserIdKey = buildFeedUserIdKeyFromAction(action);
      var feedUserIdKeyIndex = state.lastIndexOf(feedUserIdKey);
      if (feedUserIdKeyIndex === -1) {
        return state;
      }

      return [].concat(_toConsumableArray(state.slice(0, feedUserIdKeyIndex)), _toConsumableArray(state.slice(feedUserIdKeyIndex + 1)));
    default:
      return state;
  }
}